import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { Nav } from "@/components/wve/Nav";
import { Footer } from "@/components/wve/Footer";
import { Intro } from "@/components/wve/Intro";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import ServicesPage from "@/pages/ServicesPage";
import StudioPage from "@/pages/StudioPage";
import LivePage from "@/pages/LivePage";
import ContactPage from "@/pages/ContactPage";
import WorkPage from "@/pages/WorkPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import LandingPage from "@/pages/LandingPage";

function App() {
  const [intro, setIntro] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <AnimatePresence>{intro && <Intro onDone={() => setIntro(false)} />}</AnimatePresence>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/studios" element={<StudioPage />} />
          <Route path="/studio" element={<StudioPage />} />
          <Route path="/live" element={<LivePage />} />
          <Route path="/services/live-streams" element={<Navigate to="/live" replace />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/trades-promotion" element={<LandingPage />} />
          <Route path="/funeral-live-stream" element={<LandingPage />} />
          <Route path="/estate-agent" element={<LandingPage />} />
          <Route path="/artist-development" element={<LandingPage />} />
          <Route path="/video-production-chelmsford" element={<LandingPage />} />
          <Route path="/video-production-southend" element={<LandingPage />} />
          <Route path="/video-production-brentwood" element={<LandingPage />} />
          <Route path="/video-production-london" element={<LandingPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
